import React, { useEffect, useState } from 'react'
import { Link, useInRouterContext, useNavigate } from 'react-router-dom'
import { LINK_SOURCE } from './common'

const ContextFn = ({ setFunction = () => {} }) => {
  const navigate = useNavigate()
  useEffect(() => setFunction(() => navigate), [setFunction, navigate])
  return <></>
}

const redirectFn = (href) => {
  if (href) {
    window.location.href = href
  }
}

export const useCustomNavigate = () => {
  const insideRouter = useInRouterContext()
  const [funct, setFunct] = useState(() => redirectFn)
  useEffect(() => {
    if (!insideRouter) {
      setFunct(() => redirectFn)
    }
  }, [insideRouter])

  const component = insideRouter ? <ContextFn setFunction={setFunct} /> : <></>
  return [funct, component]
}
export default function CommonLink({ to, children, ...props }) {
  const insideRouter = useInRouterContext()
  let linkPath = to || props?.href
  linkPath = LINK_SOURCE ? `${linkPath}?source=${LINK_SOURCE}` : linkPath

  if (insideRouter) {
    return (
      <Link to={linkPath} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <a href={linkPath} {...props}>
      {children}
    </a>
  )
}
